import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { Box } from '../Box/index.js';

var TagLabel = forwardRef(function TagLabel(_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (jsx(Box, __assign({ ref: ref, sx: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        } }, props, { children: children })));
});

export { TagLabel };
//# sourceMappingURL=TagLabel.js.map
